export default __webpack_public_path__ + "static/media/big-deal-50DM-background.6823fcd9.jpg";